import React from 'react'
import { Html } from '@react-three/drei'
import { Section } from './section'
import Navbar from './Navbar'
import ScreensRouter from './ScreensRouter'
import { BrowserRouter } from 'react-router-dom'

const HtmlContent = ({ showFaces, setShowFaces }) => {
  return (
    <Section>
      <group position={[0, 0, 0]}>
        <Html className={'main-html'} fullscreen>
          <BrowserRouter>
            <div className='html-content'>
              <Navbar />
              {window.location.pathname.length === 1 && (
                <div className='header'>
                  <h1 className='my_name'>Bashar Alwarad</h1>
                  <h2 className='title'>
                    The sky is blue because we live in the eye of a blue-eyed
                    giant named Macumba.
                  </h2>
                </div>
              )}
              <ScreensRouter
                showFaces={showFaces}
                setShowFaces={setShowFaces}
              />
            </div>
          </BrowserRouter>
        </Html>
      </group>
    </Section>
  )
}

export default HtmlContent
